var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-dashboard-progress"
    },
    [
      _c(
        "nav",
        {
          staticClass: "cw-dashboard-progress-breadcrumb",
          attrs: {
            "aria-label": "Breadcrumb"
          }
        },
        [
          _vm.parent
            ? _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    title: _vm.$gettext("Hauptseite")
                  },
                  on: {
                    click: _vm.visitRoot
                  }
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "home"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.parent
            ? _c(
                "a",
                {
                  attrs: {
                    href: "#",
                    title: _vm.parent.name
                  },
                  on: {
                    click: function click($event) {
                      return _vm.selectChapter(_vm.parent.id)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            / " + _vm._s(_vm.parent.name) + "\n        "
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.selected
        ? _c(
            "div",
            {
              staticClass: "cw-dashboard-progress-chapter"
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.chapterUrl,
                    title: _vm.$gettextInterpolate(
                      _vm.$gettext("%{ pageTitle } öffnen"),
                      {
                        pageTitle: _vm.selected.name
                      }
                    )
                  }
                },
                [_c("h1", [_vm._v(_vm._s(_vm.selected.name))])]
              ),
              _vm._v(" "),
              _c("courseware-progress-circle", {
                attrs: {
                  title: _vm.$gettext(
                    "diese Seite inkl. darunter liegende Seiten"
                  ),
                  value: parseInt(_vm.selected.progress.cumulative)
                }
              }),
              _vm._v(" "),
              _c("courseware-progress-circle", {
                staticClass: "cw-dashboard-progress-current",
                attrs: {
                  title: _vm.$gettext("diese Seite"),
                  value: parseInt(_vm.selected.progress.self)
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-dashboard-progress-subchapter-list"
        },
        [
          _vm._l(_vm.children, function(chapter) {
            return _c("courseware-dashboard-progress-item", {
              key: chapter.id,
              attrs: {
                name: chapter.name,
                value: chapter.progress.cumulative,
                chapterId: chapter.id
              },
              on: {
                selectChapter: _vm.selectChapter
              }
            })
          }),
          _vm._v(" "),
          !_vm.children.length
            ? _c(
                "div",
                {
                  staticClass: "cw-dashboard-empty-info"
                },
                [
                  _c("courseware-companion-box", {
                    attrs: {
                      mood: "sad",
                      msgCompanion: _vm.$gettext(
                        "Diese Seite enthält keine darunter liegenden Seiten."
                      )
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }